import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=b8e97270&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8e97270')) {
      api.createRecord('b8e97270', component.options)
    } else {
      api.reload('b8e97270', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=b8e97270&", function () {
      api.rerender('b8e97270', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KcmWR5hIX4D8/JS/cancellationPolicy.vue"
export default component.exports